module.exports = __webpack_public_path__ + "static/media/3_14.b668b573.png";